/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "abf3c1b14d531844403e17829d59e6998c645902";
